module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S10 Flamingo Pink.9a9790d1.png";